<style src="./Checkbox.scss" lang="scss"></style>

<template lang="pug">
  label.checkbox(
    :class='classList'
  )
    input.checkbox__input(
      type='checkbox'
      @change='onChange'
      v-model='fieldValue'
      :name='name'
      :required='required'
    )
    span.checkbox__label(v-html="label" :title='label')
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      type: Boolean
    },
    name: {
      default: "",
      type: String
    },
    label: {
      default: "",
      type: String
    },
    mods: {
      default: () => [],
      type: Array
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      fieldValue: this.value
    };
  },
  computed: {
    classList() {
      return this.mods.map(mod => `is-${mod}`);
    }
  },
  methods: {
    onChange() {
      this.$emit("input", Boolean(this.fieldValue));
    }
  }
};
</script>
